module.exports = __webpack_public_path__ + "img/1.f5fd6e1f.jpg";